import { getActiveCompany } from '../../util/user/companySwitch';
import {
	fetchCompanyProducts,
	NO_COMPANY_PRODUCTS
} from '../components/LeftPanel/utils/companyProducts';

const NS = 'MAIN_';

export const SET_COMPANY_PRODUCTS = `${NS}SET_COMPANY_PRODUCTS`;

const setCompanyProducts = products => {
	return {
		type: SET_COMPANY_PRODUCTS,
		payload: products
	};
};

/**
 * Which products the company currently being viewed has data for.  Both the
 * sidebar and the router read this from the store, so a nav item is never shown
 * for a route that would answer Access Denied — and vice versa.
 *
 * Resolves (never rejects) with the flags, so the router can gate on it the same
 * way it gates on the application list.
 */
export const getCompanyProducts = () => dispatch =>
	fetchCompanyProducts({
		company: getActiveCompany(),
		onCached: products => dispatch(setCompanyProducts(products))
	})
		.then(products => {
			const resolved = products || NO_COMPANY_PRODUCTS;
			dispatch(setCompanyProducts(resolved));
			return resolved;
		})
		.catch(() => {
			dispatch(setCompanyProducts(NO_COMPANY_PRODUCTS));
			return NO_COMPANY_PRODUCTS;
		});
